import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// SDK base styles must load before index.css: the chat widget's Anter
// branding override in index.css ([data-chat-provider] --chat-* tokens) has
// the same CSS specificity as the SDK's own base rule, so whichever loads
// later in the compiled stylesheet wins the cascade.
import "@anter/ai-chat-sdk/styles-no-base.css";
import "./index.css";
import App from "./App";
import "./lib/webmcp";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
